import React from 'react';

interface IconFontProps {
  /** iconfont 的名称 - className={`iconfont ${name}`} */
  name: string;
  /** 自定义 <i> 标签样式 - 默认大小 16px */
  style?: React.CSSProperties;
}

export function IconFont({ name, style }: IconFontProps) {
  const presetStyle = {
    fontSize: '16px',
  };

  return <i className={`iconfont ${name}`} style={{ ...presetStyle, ...style }} />;
}
